import { render } from "./facture.vue?vue&type=template&id=0b14a15d&scoped=true"
import script from "./facture.vue?vue&type=script&lang=js"
export * from "./facture.vue?vue&type=script&lang=js"

import "./facture.vue?vue&type=style&index=0&id=0b14a15d&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b14a15d"]])

export default __exports__